<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Chapter">
<p id="rw-p_110260-00001"><a id="pb-rw_xvii">
</a></p><a id="pb-rw_xvii">
</a><div class="title-block" id="rw-title-block_110260-00001"><a id="pb-rw_xvii">
</a><h1><a id="pb-rw_xvii"></a><a href="#/9781847674951_tableofcontents"><i>Abbreviations Used by Scott</i>
</a></h1>
</div>
<div class="table" id="rw-table_110260-00001">
<div class="pc">
<table id="ta"><caption><br/></caption>
<tbody>
<tr class="row1">
<td class="col2">1. Advocate, The</td>
<td class="col2"> </td>
<td class="col3">The Lord Advocate, Sir William Rae</td>
</tr>
<tr class="row2">
<td class="col2">2. C and Coy.</td>
<td class="col2"> </td>
<td class="col3">Constable and Company</td>
</tr>
<tr class="row3">
<td class="col2">3. Ch. Ba.</td>
<td class="col2"> </td>
<td class="col3">The Lord Chief Baron of the Exchequer Court, Sir Samuel Shepherd</td>
</tr>
<tr class="row4">
<td class="col2">4. Ch. Com.</td>
<td class="col2"> </td>
<td class="col3">The Lord Chief Commissioner of the Jury Court, the Rt. Hon. William Adam</td>
</tr>
<tr class="row5">
<td class="col2">5. Chief Baron</td>
<td class="col2"> </td>
<td class="col3">See 3 above</td>
</tr>
<tr class="row6">
<td class="col2">6. Chief Commissioner</td>
<td class="col2"> </td>
<td class="col3">See 4 above</td>
</tr>
<tr class="row7">
<td class="col2">7. H &amp; R</td>
<td class="col2"> </td>
<td class="col3">Hurst, Robinson and Company</td>
</tr>
<tr class="row8">
<td class="col2">8. James  <br/>James B <br/>J. B.
                        </td>
<td class="col2"><img alt="alt" src="xvii.png"/>
</td>
<td class="col3">James Ballantyne </td>
</tr>
<tr class="row9">
<td class="col2">9. J. G. L.</td>
<td class="col2"> </td>
<td class="col3">John Gibson Lockhart</td>
</tr>
<tr class="row10">
<td class="col2">10. L. C. B.</td>
<td class="col2"> </td>
<td class="col3">See 3 above</td>
</tr>
<tr class="row11">
<td class="col2">11. L. C. C.</td>
<td class="col2"> </td>
<td class="col3">See 4 above</td>
</tr>
<tr class="row12">
<td class="col2">12. Lord Ch: Com.</td>
<td class="col2"> </td>
<td class="col3">See 4 above</td>
</tr>
<tr class="row13">
<td class="col2">13. L. J. C.</td>
<td class="col2"> </td>
<td class="col3">The Lord Justice-Clerk, the Rt. Hon. David Boyle</td>
</tr>
<tr class="row14">
<td class="col2">14. L. J. S.</td>
<td class="col2"> </td>
<td class="col3">Lady Jane Stuart</td>
</tr>
<tr class="row15">
<td class="col2">15. L. L. S.</td>
<td class="col2"> </td>
<td class="col3">Lady Louisa Stuart</td>
</tr>
<tr class="row16">
<td class="col2">16. Lord Register</td>
<td class="col2"> </td>
<td class="col3">The Principal Keeper of the Register of Sasines, the Rt. Hon. William Dundas</td>
</tr>
<tr class="row17">
<td class="col2">17. L. S.</td>
<td class="col2"> </td>
<td class="col3">Lady Scott</td>
</tr>
<tr class="row18">
<td class="col2">18. Missie</td>
<td class="col2"> </td>
<td class="col3">Miss Macdonald Buchanan</td>
</tr>
<tr class="row19">
<td class="col2">19. R. C.</td>
<td class="col2"> </td>
<td class="col3">Robert Cadell</td>
</tr>
<tr class="row20">
<td class="col2">20. Sir A. F.</td>
<td class="col2"> </td>
<td class="col3">Sir Adam Ferguson</td>
</tr>
<tr class="row21">
<td class="col2">21. Solicitor, The</td>
<td class="col2"> </td>
<td class="col3">The Solicitor-General, John Hope</td>
</tr>
<tr class="row22">
<td class="col2">22. S. W. S.</td>
<td class="col2"> </td>
<td class="col3">Sir Walter Scott</td>
</tr>
<tr class="row23">
<td class="col2">23. W. C.</td>
<td class="col2"> </td>
<td class="col3">Will Clerk</td>
</tr>
<tr class="row24">
<td class="col2">24. <i>W—k</i>.
                        </td>
<td class="col2"> </td>
<td class="col3"><i>Woodstock</i>
</td>
</tr>
</tbody>
</table>
</div>
</div>
<p class="fp" id="rw-p_110260-00002"><a id="pb-rw_xviii">
</a></p><a id="pb-rw_xviii">
</a></div><a id="pb-rw_xviii">
</a></div><a id="pb-rw_xviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847674951_chapter_01.vue?54374189